import { app } from '../../../../../../app';
import { Controller } from './bulk-verification-result.controller';

app.component('companyUserDirectoriesManageGroupAccountsBulkVerificationResult', {
    bindings: {
        connectionDetails: '<',
        importedUsers: '<',
    },
    controller: Controller,
    templateUrl: require('./bulk-verification-result.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/bulk-verification-result/bulk-verification-result.component.js